
























































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {NotificationStore} from "@/modules/notifications/store";
import {NotificationTargetType, NotificationType} from "@/enums/type";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import {CustomerStore} from "@/modules/customers/store";

const form = {
    title: undefined,
    description: undefined,
    content: undefined,
    type: NotificationType.Basic,
    targetType: undefined,
    accountRowGuid: undefined,
    customerRowGuid: undefined
};
@Component({
    name: "NotificationEmployeeForm",
    components: {CustomerSelector, EmployeeSelector}
})
export default class extends Vue {

    private form = { ...form };

    private rules = {
        title: [{ required: true, message: "Nhập tiêu đề", trigger: "change" }],
        description: [{ required: true, message: "Nhập mô tả", trigger: "change" }],
        content: [{ required: true, message: "Nhập nội dung", trigger: "change" }],
    };

    private onSubmit() {
        (this.$refs.formNotification as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                if (this.form.customerRowGuid) {
                  this.form.accountRowGuid = CustomerStore.data[this.form.customerRowGuid as any]?.accountRowGuid as any
                    this.form.targetType = NotificationTargetType.Single as any;
                } else {
                    this.form.targetType = NotificationTargetType.Customer as any;
                }
                await NotificationStore.createNotification(this.form);
                this.$message.success("Gửi thông báo thành công");
                this.form = { ...form };
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `Gửi thông báo thất bại`}`)
            }
        })
    }
}
